import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";

import "./styles/base.less";
import vuetify from "./plugins/vuetify";
import vuescroll from 'vuescroll';
import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';
const {registerLogger} = require('./modules/Logger');

registerLogger(Vue);

Vue.use(VueAxios, axios);
Vue.use(VueToast);
Vue.use(vuescroll, {
    ops: {
        rail: {
            opacity: '0',
            background: '#5e8da8',
            size: '6px'
        },
        bar: {
            background: '#5e8da8',
            keepShow: false,
            size: '4px',
            minSize: 0.2
        },
        scrollButton: {
            enable: true,
            background: '#5e8da8'
        },
        scrollPanel: {
            easing: 'easeInQuad',
            speed: 800
        },
    },
    name: 'vue-scroll'
});

Vue.config.productionTip = false;
Vue.axios.defaults.baseURL = process.env.VUE_APP_API_URL;

//And here our App
let app = new Vue({
    router,
    store,
    vuetify,
    render: h => h(App)
}).$mount("#app");
